//#region IMPORT
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import FileUploadDialog from '../../../../Components/FileUploadDialog/FileUploadDialog';
import dayjs from 'dayjs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { ExcelGridCommon } from '../../../../Components/ExcelGridCommon';
import ExcelUploadCommon from '../../../../Components/ExcelUploadCommon/ExcelUploadCommon';
import { getColumnDefs1 } from './PPE_BASIC_01_ColumnDefs';
//#endregion

/** 개발 모드: 비고(remark) 셀 타입·편집 흐름 추적용 */
const DEBUG_PPE_REMARK = process.env.NODE_ENV === 'development';

function PPE_BASIC_01(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);

  // 보호구 등록 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // 현재 탭이 0번이 아닌 경우 처리하지 않음
    if (props.value !== 0) return;

    if (props.filterClick1) {
      if (!props.validateSelection()) {
        props.setFilterClick1(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo.searchText);
      props.setFilterClick1(false);
    }
    if (props.searchClick1) {
      props.ResetLogic1();
      if (!props.validateSelection()) {
        props.setSearchClick1(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick1(false);
    }
    if (props.addClick1) {
      if (!props.validateSelection()) {
        props.setAddClick1(false);
        return;
      }

      props.setAddClick1(false);
    }
    if (props.saveClick1) {
      if (!props.validateSelection()) {
        props.setSaveClick1(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick1(false);
    }
    if (props.deleteClick1) {
      if (!props.validateSelection()) {
        props.setDeleteClick1(false);
        return;
      }

      props.DeleteLogic1();
      props.setDeleteClick1(false);
    }
    if (props.printClick1) {
      if (!props.validateSelection()) {
        props.setPrintClick1(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick1(false);
    }
  }, [
    props.value,
    props.filterClick1,
    props.searchClick1,
    props.addClick1,
    props.saveClick1,
    props.deleteClick1,
    props.printClick1,
    props.listClick1,
  ]);
  //#endregion

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (props.readyToExport && props.gridRef2.current) {
      props.gridRef2.current.api.exportDataAsExcel({
        fileName: dayjs().format('YYYYMMDDHHmm') + '보호구등록.xlsx',
        processCellCallback: (params) => {
          // 사용부서와 담당자는 원본 데이터의 코드값을 그대로 사용
          // valueFormatter로 포맷된 값이 아닌 원본 데이터의 코드값을 엑셀에 저장
          if (params.column.getColId() === 'managerDepartment') {
            if (params.node.data?.useDepartmentScope === 'ALL') return '전체';
            return (
              params.node.data?.managerDepartmentNames ||
              params.node.data?.managerDepartments?.join?.(',') ||
              params.value ||
              ''
            );
          }
          if (params.column.getColId() === 'managerId') {
            return params.node.data?.managerId || params.value || '';
          }
          return params.value;
        },
      });
      props.setReadyToExport(false); // 여러 번 클릭 방지
    }
  }, [props.readyToExport]);
  return (
    <React.Fragment>
      <BusinessGridCommon
        gridContext={{
          setChangedRowData: props.setChangedRowData1,
        }}
        gridSx={{
          '& .ag-cell[col-id="managerDepartment"]': {
            overflow: 'visible',
          },
        }}
        getRowId={(params) => {
          return params.data.no;
        }}
        fileDownloadYn1="Y"
        fileDownloadClick1={() => {
          if (!props.validateSelection()) return;

          props.ExcelDownload();
        }}
        fileUploadYn1="Y"
        fileUploadClick1={() => {
          if (!props.validateSelection()) return;

          props.fileInputRef.current.click();
        }}
        addClick1={() => {
          if (!props.validateSelection()) return;

          GridFunctions.addClick(props.gridRef1, props.setChangedRowData1);
        }}
        deleteClick1={(e) => {
          if (!props.validateSelection()) return;

          const newRowExists = props.selectedRowData1.some(
            (row) => row.newYn === 'Y'
          );

          if (!newRowExists) {
            props.MarkedForDeletion1(props.selectedRowData1);
          } else {
            props.NewYnErrorMsg();
          }
        }}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
        }}
        title1={'보호구 등록'}
        gridRef={props.gridRef1}
        editable={true}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        rowSelection={'multiple'}
        onCellClicked={(e) => {
          // 필요 시 특정 행 선택 등 처리
          const gridApi = props.gridRef1.current.api;
          const clickedRowIndex = e.rowIndex;

          const isCheckboxClick = e.event?.target?.type === 'checkbox';

          if (!isCheckboxClick) {
            gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
            gridApi.setFocusedCell(clickedRowIndex, 'coNm');

            const copied = JSON.parse(JSON.stringify(e.data));
            props.handleRowSelection(copied, clickedRowIndex);

            gridApi
              .getDisplayedRowAtIndex(clickedRowIndex)
              ?.setSelected(true, false);
          }
        }}
        onSelectionChanged={() => {
          const gridApi = props.gridRef1?.current?.api;
          const selectedNodes = gridApi.getSelectedNodes();
          const selectedData = selectedNodes.map((n) => n.data);
          props.selectedRowNosRef.current = new Set(
            selectedData.map((r) => r.no)
          );
          props.setSelectedRowData1(selectedData);
        }}
        onCellEditingStarted={(e) => {
          if (!DEBUG_PPE_REMARK) return;
          const colId = e.column?.getColId?.();
          if (colId !== 'remark') return;
          const v = e.value;
          // eslint-disable-next-line no-console
          console.warn('[PPE remark] 편집 시작', {
            typeof값: typeof v,
            값: v,
            ctor: v?.constructor?.name,
            rowRemark: e.data?.remark,
            colId,
            cellEditor: e.colDef?.cellEditor,
          });
        }}
        onCellEditingStopped={(e) => {
          if (!DEBUG_PPE_REMARK) return;
          const colId = e.column?.getColId?.();
          if (colId !== 'remark') return;
          // eslint-disable-next-line no-console
          console.warn('[PPE remark] 편집 종료', {
            oldValue: e.oldValue,
            newValue: e.newValue,
            typeof_new: typeof e.newValue,
            colId,
          });
        }}
        onCellValueChanged={(e, gridRef) => {
          if (e.column?.getColId?.() === 'filePath') {
            return;
          }
          if (DEBUG_PPE_REMARK && e.column?.getColId?.() === 'remark') {
            // eslint-disable-next-line no-console
            console.warn('[PPE remark] 값 변경', {
              oldValue: e.oldValue,
              newValue: e.newValue,
              typeof_old: typeof e.oldValue,
              typeof_new: typeof e.newValue,
            });
          }
          GridFunctions.onCellValueChanged(
            e,
            gridRef,
            props.setChangedRowData1,
            undefined,
            undefined
          );
        }}
      />
      {props.fileModalToggle && (
        <FileUploadDialog
          open={props.fileModalToggle}
          onClose={() => {
            props.setFileModalToggle(false);
          }}
          gridRef={props.gridRef1}
          selectedRowData={props.selectedRowData1}
          setSelectedRowData={props.setSelectedRowData1}
          setChangedRowData={props.setChangedRowData1}
          fileNameField="fileName"
          saveNameField="saveName"
          filePathField="filePath"
          SaveLogicPreview={props.SaveLogicPreview}
          DownloadLogic={props.DownloadLogic1}
        />
      )}
      <ExcelGridCommon
        gridRef={props.gridRef2}
        rowData={props.excelData}
        columnDefs={columnDefs1}
        rowSelection="multiple"
      />
      <ExcelUploadCommon
        fileInputRef={props.fileInputRef}
        gridRef={props.gridRef1}
        rowData={props.rowData1}
        columnDefs={columnDefs1}
        setChangedRowData={props.setChangedRowData1}
        setDeletedRowData={props.setDeletedRowData1}
        depList={props.depList}
        memberList={props.memberList}
      />
    </React.Fragment>
  );
}

export default PPE_BASIC_01;
